module.exports = __webpack_public_path__ + "static/media/ic_star_24px.164d391a.svg";